import {
	API_GET_ALL_SPECIAL_REGIME,
	API_GET_ALL_SPECIAL_REGIME_SUCCESS,
	API_GET_ALL_SPECIAL_REGIME_FAIL,
} from '../actions/specialRegime';
import { createReducer } from '@reduxjs/toolkit';
import { ErrorAction, errorHandler } from 'utils/error';

const initialState = {
    loading: false,
	list: []
};

const specialRegimes = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_SPECIAL_REGIME]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_SPECIAL_REGIME_FAIL]: (state, action) => {
		errorHandler('Régime spécial', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_SPECIAL_REGIME_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},

});

export default specialRegimes;
